import turfCircle from '@turf/circle'
import turfBooleanContains from '@turf/boolean-contains'
import {point as turfPoint, polygon as turfPolygon} from '@turf/helpers'
import MapsProviderEnum from '@/app-core/api/enums/MapsProviderEnum'
import DeliveryServiceCommon from '@/app-core/mixins/services/deliveryServiceCommon'
import CustomerAddressResource from '@/app-core/api/resources/customer/CustomerAddressResource'
import {filterNonUnique} from '@/app-core/lib/utils/array'
import {clone} from '@/app-core/lib/utils/helper'
import ServiceTypeEnum from '@/app-core/api/enums/ServiceTypeEnum'
import API from '@/app-core/api/Api'

export default {
  mixins: [DeliveryServiceCommon],
  data() {
    return {
      selectedCity    : null,
      selectedStreet  : null,
      selectedLocation: null,
      mapCenter       : {
        lat: -1,
        lng: -1
      },
      markerStore: {
        lat: -1,
        lng: -1
      },
      markerAddress: {
        lat: -1,
        lng: -1
      }
    }
  },
  created() {
    this.mapCenter = this.markerStore = this.markerAddress = {
      lat: this.AppConfig?.Marketplace?.Location?.Lat || -1,
      lng: this.AppConfig?.Marketplace?.Location?.Lng || -1
    }

  },
  methods: {
    initMapCenter(address) {
      this.selectedLocation = this.selectedStreet = this.selectedCity = address ? this.addressToPlaceObject(address) : null
      this.$nextTick(() => {
        this.mapCenter = this.markerAddress = this.markerStore = {
          lat: this.AppConfig?.Marketplace?.Location?.Lat || -1,
          lng: this.AppConfig?.Marketplace?.Location?.Lng || -1
        }
      })
    },

    isCustomAddress(address) {
      return address && parseFloat(address.Lng) === 0 && parseFloat(address.Lat) === 0
    },

    placeToAddressObject(place) {
      return {
        ...this.address,
        ...{
          Provider   : place?.Provider || '',
          PlaceId    : place?.Id || '',
          Formatted  : place?.Name || '',
          Lat        : place?.LatLng?.lat || '',
          Lng        : place?.LatLng?.lng || '',
          City       : place?.Properties?.City || '',
          Street     : place?.Properties?.Street || '',
          Country    : place?.Properties?.Country || '',
          CountryCode: place?.Properties?.CountryCode || '',
          Number     : place?.Properties?.Number || '',
          Postcode   : place?.Properties?.Postcode || ''
        }
      }
    },

    addressToPlaceObject(address) {
      return {
        Provider: address.Provider || MapsProviderEnum.Google,
        Id      : address?.PlaceId || '',
        Name    : address?.Formatted || '',
        Center  : [parseFloat(address?.Lng || -1), parseFloat(address?.Lat || -1)],
        LatLng  : {
          lng: parseFloat(address?.Lng || -1),
          lat: parseFloat(address?.Lat || -1)
        },
        Properties: {
          Number     : address?.Number || '',
          Postcode   : address?.Postcode || '',
          City       : address?.City || '',
          Street     : address?.Street || '',
          Country    : address?.Country || '',
          CountryCode: address?.CountryCode || ''
        },
        Raw: address.Raw || null
      }
    },

    setAddressFromPlace(place, noLimits = false) {
      if (!place) return

      if (!noLimits) {
        this.validateAddress(place)
      } else {
        this.setCustomerAddressFields(place)
      }
    },

    clearSelectedAddress() {
      if (this.$refs?.addressForm) this.$refs.addressForm.reset()
      this.clearCustomerAddressFields()
    },

    clearCustomerAddressFields() {
      this.selectedLocation = this.selectedCity = this.selectedStreet = null

      this.address = this.defaultEmptyAddress()
      this.initMapCenter()
    },

    defaultEmptyAddress() {
      return new CustomerAddressResource()
    },

    setCustomerAddressFields(place) {
      if (!place) return

      this.$set(this, 'selectedLocation', place)
      this.$set(this, 'selectedCity', place)
      this.$set(this, 'selectedStreet', place)

      this.address = this.placeToAddressObject(place)
    },

    getAddressLatLng(address) {
      return {
        lng: parseFloat(address?.Lng || address?.lng || -1),
        lat: parseFloat(address?.Lat || address?.lng || -1)
      }
    },

    getAddressFormatted(address, withCountry = false) {
      const country = address.Country || address.CountryCode || ''
      const numberSeparator = address.Street ? ' ' : ''
      const citySeparator = address.Street || address.Number ? ', ' : ''
      const postcodeSeparator = address.Street || address.Number || address.City ? ' ' : ''
      const countrySeparator = address.Street || address.Number || address.City || address.Postcode ? ', ' : ''

      let retVal = ''
      retVal += address.Street ? address.Street : ''
      retVal += address.Number ? numberSeparator + address.Number : ''
      retVal += address.City ? citySeparator + address.City : ''
      retVal += address.Postcode ? postcodeSeparator + address.Postcode : ''
      retVal += country && withCountry ? countrySeparator + country : ''

      return retVal
    },

    getAddress() {

    },

    toMapBoxPoint(point) {
      return [parseFloat(point?.lng || -1), parseFloat(point?.lat || -1)]
    },

    notifyUserOutOfBoundsAddress(shouldNotify = false) {
      if (!shouldNotify) return

      this.$bus.$emit('app:show-notification', {
        title: '',
        body : this.$t('Checkout.Details.DeliveryDetails.Notification.OutOfBounds'),
        type : 'error',
        icon : ''
      })

    },

    async validateAddress(place) {
      const result = await this.isPlaceInsideDeliveryAreas(place)

      if (result) {
        this.setCustomerAddressFields(place)
      } else {
        this.clearSelectedAddress()
        this.notifyUserOutOfBoundsAddress()
      }
    },

    async isPlaceInsideDeliveryCountries(place) {
      if (!place) return false

      try {
        const payload = {
          Lat: place?.LatLng?.lat || -1,
          Lng: place?.LatLng?.lng || -1
        }
        const response = await API.Resource.Account.AddressValidate(payload)
        return response?.data?.status === 'success'
      } catch (e) {
        return false
      }
    },

    async isPlaceInsideDeliveryAreas(place) {
      if (!place) return

      // Check if point belongs to custom address
      if (this.acceptCustomAddresses && place?.LatLng?.lat === 0 && place?.LatLng?.lng === 0) return true

      //console.log('Store Areas', this.cartStoresHaveDeliveryAreas, this.cartStoresAreaCircles, this.cartStoresAreaPolygons)
      //console.log('Marketplace Areas', this.deliveryServiceHasDeliveryAreas, this.deliveryServiceAreaCircles, this.deliveryServiceAreaPolygons)

      // Areas From Marketplace
      if (this.AppConfig?.Marketplace?.DeliveryServiceType === ServiceTypeEnum.GLOBAL) {
        if (!this.deliveryServiceHasDeliveryAreas) {
          try {
            return await this.isPlaceInsideDeliveryCountries(place)
          } catch (e) {
            return false
          }
        }

        let i = 0
        for (i = 0; i < this.deliveryServiceAreaCircles.length; i++) {
          const options = {
            steps: 10,
            units: 'kilometers'
          }
          const result = turfBooleanContains(turfCircle(this.toMapBoxPoint(this.deliveryServiceAreaCircles[i].center), this.deliveryServiceAreaCircles[i].radius, options), turfPoint(place.Center))
          if (result) return true
        }

        for (i = 0; i < this.deliveryServiceAreaPolygons.length; i++) {
          const result = turfBooleanContains(turfPolygon([this.deliveryServiceAreaPolygons[i]]), turfPoint(place.Center))
          if (result) return true
        }
      }

      // Areas Per Store
      if (this.AppConfig?.Marketplace?.DeliveryServiceType === ServiceTypeEnum.STORE) {
        if (!this.cartStoresHaveDeliveryAreas) {
          try {
            return await this.isPlaceInsideDeliveryCountries(place)
          } catch (e) {
            return false
          }
        }

        let i = 0
        for (i = 0; i < this.cartStoresAreaCircles.length; i++) {
          const options = {
            steps: 10,
            units: 'kilometers'
          }
          const result = turfBooleanContains(turfCircle(this.toMapBoxPoint(this.cartStoresAreaCircles[i].center), this.cartStoresAreaCircles[i].radius, options), turfPoint(place.Center))
          if (result) return true
        }

        for (i = 0; i < this.cartStoresAreaPolygons.length; i++) {
          const result = turfBooleanContains(turfPolygon([this.cartStoresAreaPolygons[i]]), turfPoint(place.Center))
          if (result) return true
        }
      }

      return false
    },

    async isPlaceInsideStoreDeliveryAreas(place, storeId) {
      if (!place) return

      // Check if point belongs to custom address
      if (this.acceptCustomAddresses && place?.LatLng?.lat === 0 && place?.LatLng?.lng === 0) return true

      if (!this.cartStoreHasDeliveryAreas(storeId)) {
        try {
          return await this.isPlaceInsideDeliveryCountries(place)
        } catch (e) {
          return false
        }
      }

      const areaCircles = this.cartStoreAreaCircles(storeId)
      const areaPolygons = this.cartStoreAreaPolygons(storeId)

      let i = 0
      for (i = 0; i < areaCircles.length; i++) {
        const options = {
          steps: 10,
          units: 'kilometers'
        }
        const result = turfBooleanContains(turfCircle(this.toMapBoxPoint(areaCircles[i].center), areaCircles[i].radius, options), turfPoint(place.Center))
        if (result) return true
      }

      for (i = 0; i < areaPolygons.length; i++) {
        const result = turfBooleanContains(turfPolygon([areaPolygons[i]]), turfPoint(place.Center))
        if (result) return true
      }


      return false
    },

    cartStoreAreaCircles(storeId) {
      const store = this.AppStores.find(store => store.Id === storeId)
      const retVal = []

      for (const key in store.Areas) {
        if (store.Areas.hasOwnProperty(key)) {
          const obj = store.Areas[key]
          if (obj.type === 'circle') {
            const circle = clone(obj.circle)
            circle.radius = circle.radius / 1000
            retVal.push(circle)
          }
        }
      }

      return retVal
    },

    cartStoreAreaPolygons(storeId) {
      const store = this.AppStores.find(store => store.Id === storeId)
      const retVal = []

      for (const key in store.Areas) {
        if (store.Areas.hasOwnProperty(key)) {
          const obj = store.Areas[key]
          if (obj.type === 'shape') {
            const vertices = obj.vertices.map(v => this.toMapBoxPoint(v))
            vertices.push(vertices[0])
            retVal.push(vertices)
          }
        }
      }

      return retVal
    },

    cartStoreHasDeliveryAreas(storeId) {
      return this.cartStoreAreaCircles(storeId).length > 0 || this.cartStoreAreaPolygons(storeId).length > 0
    }
  },
  computed: {
    acceptCustomAddresses() {
      return this.AppConfig?.Marketplace?.AllowCustomAddresses || false
    },
    acceptLatLngAddresses() {
      return this.AppConfig?.Marketplace?.AllowLatLngAddresses || false
    },

    locationDeliveryCountriesStr() {
      return this.AppConfig?.Marketplace?.Location?.Country?.Code || 'GR'
    },

    cartStoresHaveDeliveryAreas() {
      return this.cartStoresAreaCircles.length > 0 || this.cartStoresAreaPolygons.length > 0
    },

    cartStoresAreaPolygons() {
      const cartStoreIds = filterNonUnique(this.AppCart?.Items?.map(item => item.StoreId) || [])
      const cartStores = this.AppStores.filter(store => cartStoreIds.includes(store.Id))
      const retVal = []

      cartStores.forEach(storeDelivery => {
        for (const key in storeDelivery.Areas) {
          if (storeDelivery.Areas.hasOwnProperty(key)) {
            const obj = storeDelivery.Areas[key]
            if (obj.type === 'shape') {
              const vertices = obj.vertices.map(v => this.toMapBoxPoint(v))
              vertices.push(vertices[0])
              retVal.push(vertices)
            }
          }
        }
      })

      return retVal
    },

    cartStoresAreaCircles() {
      const cartStoreIds = filterNonUnique(this.AppCart?.Items?.map(item => item.StoreId) || [])
      const cartStores = this.AppStores.filter(store => cartStoreIds.includes(store.Id))
      const retVal = []

      cartStores.forEach(storeDelivery => {
        for (const key in storeDelivery.Areas) {
          if (storeDelivery.Areas.hasOwnProperty(key)) {
            const obj = storeDelivery.Areas[key]
            if (obj.type === 'circle') {
              const circle = clone(obj.circle)
              circle.radius = circle.radius / 1000
              retVal.push(circle)
            }
          }
        }
      })

      return retVal
    },

    deliveryServiceAreaPolygons() {
      const deliveryAreas = this.deliveryServiceDeliveryAreas || []
      const retVal = []

      for (const key in deliveryAreas) {
        if (deliveryAreas.hasOwnProperty(key)) {
          const obj = deliveryAreas[key]
          if (obj.type === 'shape') {
            const vertices = obj.vertices.map(v => this.toMapBoxPoint(v))
            vertices.push(vertices[0])
            retVal.push(vertices)
          }
        }
      }

      return retVal
    },

    deliveryServiceAreaCircles() {
      const deliveryAreas = this.deliveryServiceDeliveryAreas || []
      const retVal = []

      for (const key in deliveryAreas) {
        if (deliveryAreas.hasOwnProperty(key)) {
          const obj = deliveryAreas[key]
          if (obj.type === 'circle') {
            const circle = clone(obj.circle)
            circle.radius = circle.radius / 1000
            retVal.push(circle)
          }
        }
      }

      return retVal
    }
  }
}
